import React from 'react'
import Input from 'app/theme/forms/Input'
import LeadError from '../LeadError'

export default function LeadEvent(props) {
  const { data, setData, errors, setErrors } = props

  return (
    <div>
      <div className="p-8 grid gap-6 md:grid-cols-2">
        <Input
          autoFocus
          value={data.event_name}
          error={errors?.event_name ? <LeadError className="text-center" message={errors.event_name} /> : null}
          data-test-id='event_name'
          placeholder={data.recurring ? 'Location Name' : 'Event Name'}
          classNames={{
            input: 'input-underline',
          }}
          onChange={event_name => {
            setErrors(false)
            setData(prev => ({
              ...prev,
              event_name,
            }))
          }}
        />
        <Input
          value={data.website}
          placeholder="Website"
          data-test-id='event_website'
          classNames={{
            input: 'input-underline',
          }}
          onChange={website => {
            setData(prev => ({
              ...prev,
              website,
            }))
          }}
        />
      </div>
    </div>
  )
}
